import { ProjectDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectManagementService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getProjectManagement(): Observable<ProjectDto[]> {
    return this.http.get<ProjectDto[]>(this.url + 'project');
  }

  createProjectManagement(data: ProjectDto): Observable<ProjectDto> {
    return this.http.post<ProjectDto>(this.url + 'project', data);
  }

  createProjectSub(data: ProjectDto): Observable<ProjectDto> {
    return this.http.post<ProjectDto>(this.url + 'project/sub', data);
  }

  uploadExcelProjectManagement(data: ProjectDto[]): Observable<ProjectDto[]> {
    return this.http.post<ProjectDto[]>(this.url + 'project/upload', data);
  }

  getSingleProjectManagement(id: string): Observable<any> {
    return this.http.get(this.url + 'project/' + id);
  }

  updateProjectManagement(data: ProjectDto): Observable<ProjectDto> {
    return this.http.post<ProjectDto>(this.url + 'project/update', data);
  }

  deleteProjectManagement(ids: any[]) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('bank', ids.join(', '));
    return this.http.delete(this.url + 'project', httpOptions);
  }

  deleteProjectManagementStakeholder(ids: any[]) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('bank', ids.join(', '));
    return this.http.delete(
      this.url + 'project/delete-stakeholder',
      httpOptions
    );
  }

  deleteProjectManagementCluster(ids: any[]) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('project/delete-cluster', ids.join(', '));
    return this.http.delete(this.url + 'project/delete-cluster', httpOptions);
  }

  deleteProjectManagementReportMaster(ids: any[]) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('bank', ids.join(', '));
    return this.http.delete(this.url + 'project/delete-master', httpOptions);
  }

  deleteProjectManagementMeeting(ids: any[]) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('bank', ids.join(', '));
    return this.http.delete(this.url + 'project/delete-meeting', httpOptions);
  }

  deleteProjectManagementMain(id: string) {
    return this.http.delete(this.url + 'project/' + id);
  }
}
